import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PonderDataClientBase } from "./ponder-data-client-base";
import { environment } from "../../../environments/environment";

@Injectable( { providedIn: 'root' })
export class PonderDataClient extends PonderDataClientBase {
    public constructor(@Inject(HttpClient) httpClient: HttpClient) {
        super(httpClient, `${environment.ponderBaseUrl}/data`);
    }
}

export enum DeckLayerName {
    Mainboard = "Mainboard",
    Sideboard = "Sideboard",
    Maybeboard = "Maybeboard",
    Planning = "Planning"
}